import { ListBase } from 'react-admin';
import { TaskListLayout } from './TaskListLayout';

export const TaskList = () => {
    return (
        <ListBase
            resource="task"
            perPage={25}
            sort={{ field: 'dueDate', order: 'ASC' }}
            filterDefaultValues={{ doneDate: 'is.null' }}
        >
            <TaskListLayout />
        </ListBase>
    );
};
